export class StudentAssignmentReport {
    StudentName: string;
    CompletedActivities: CompletedActivity[];
    StudentID: number;
}

export class StudentCompletedCourseActivities
{
    StudentID: number;
    CourseCode: string;
    CompletedActivities: CompletedActivity[];
}

export class CompletedActivity {
    SessionID: string;
    ActivityID: string;
    UnitNumber: number;
    Context: string;
    AssignedActivityID: string;
    StartedActivityID: string;
    StartedAt: string;
    CompletedAt: string;
    ResultCode: string;
}